import { autoinject } from 'aurelia-framework';
import { ComponentBase, SortDirection, Sorting } from 'app/shared/lib/essette-site';
import { Api } from 'app/shared/lib/essette-api';
import { guid } from 'app/shared/lib/guid';
import { I18N } from 'aurelia-i18n';
import { IListItem } from 'app/shared/elements/ess-sortable-list';

interface ExampleListItem extends IListItem {
    description: string;
}

@autoinject()
export class DemoEssSortableListPage extends ComponentBase {
    ////****************** Fields and Properties ************************************////
    protected id: guid = guid();

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        protected readonly api: Api,
        private readonly i18n: I18N,
        ...rest: any[]) {
        super(...rest);
    }

    protected bind(): void {
        this.reload();
    }

    ////****************** Functions ************************************************////
    protected reload() {
        this.loadListItems();
    }

    protected loadListItems() {
        this.ex1Items = [
            { order: 1, id: "1", value: "Glazed", description: "Plain doughnut batter with a sugary glaze", isActive: true },
            { order: 2, id: "2", value: "Chocolate", description: "Chocolate doughnut batter with a powder sugar coat", isActive: true },
            { order: 3, id: "3", value: "Boston Cream", description: "Plain doughnut batter, half chocolate dipped, with a creme filling", isActive: true },
            { order: 4, id: "4", value: "Glazed Chocolate", description: "Chocolate doughnut batter with a sugary glaze", isActive: true },
            { order: 5, id: "5", value: "Blueberry", description: "Plain doughnut batter with a sugary glaze and blueberry pieces throughout", isActive: true },
            { order: 6, id: "6", value: "Inactiveberry", description: "Plain doughnut batter with infused inActivity", isActive: false }
        ];
    }

    ////****************** Example 1 ************************************************////
    protected ex1Items: ExampleListItem[] = [];
}
